export default __webpack_public_path__ + "static/media/AlishaSwan.d4871f39.png";